import React from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { useTranslation } from 'react-i18next';
import { noraWebTheme } from './noraWebTheme';

export default function ListItemI18NBig(props) {
  
  const { t } = useTranslation('news');
  const transval = t(props.ns + props.k);
  const label = !!(props.labelKey)?t(props.labelKey):null;
  const ret = !!(label)? label + ': ' + transval: transval;

  const ListItemTextStyling = {
    '& .MuiListItemText-primary': {
      [noraWebTheme.breakpoints.down('sm')]: {
        fontSize: '1.3rem',
        fontWeight:'Bold',
        m:-1,
        p:0,
      },
      [noraWebTheme.breakpoints.up('sm')]: {
        fontSize: '1.6rem',
        fontWeight:'Bold',
        m:-1,
        p:0,
      },
    },
  };

  return (
    <>
      {(transval===props.k)?null:<ListItem dense={true} sx={{p:0,m:0,pl:2}}><ListItemText sx={ListItemTextStyling} primary={ret} /></ListItem>} 
    </>
  )
}
